import Image from 'next/image';
import Link from 'next/link';

import { Container, Left, ImageContainer } from './styles';

import { useTheme } from '@/components/global/Providers/Theme';

import { BsArrowRight } from 'react-icons/bs';

import SectionImageDark from '@/images/Pages/Aplicativos/Integracao/section-image-dark.png';
import SectionImageLight from '@/images/Pages/Aplicativos/Integracao/section-image-light.png';

const Integracao: React.FC = () => {
  const { currentTheme } = useTheme();

  return (
    <Container>
      <Left>
        <h2>Integração com Notificações via WhatsApp</h2>
        <p>
          Nossos aplicativos web se conectam ao seu WhatsApp para enviar
          notificações, mantendo seu cliente informado sobre cada etapa da
          coleta e entrega.
        </p>
        <ImageContainer className="mobile">
          <Image
            src={
              currentTheme === 'light' ? SectionImageLight : SectionImageDark
            }
            quality={100}
            placeholder="blur"
            alt="Imagem de um celular mostrando o app do Transporte Generoso recebendo uma notificação no WhatsApp"
          />
        </ImageContainer>
        <Link href="/notificacoes" passHref>
          <a>
            Conheça as Notificações{' '}
            <span>
              <BsArrowRight size={24} />
            </span>
          </a>
        </Link>
      </Left>

      <ImageContainer className="desktop">
        <Image
          src={currentTheme === 'light' ? SectionImageLight : SectionImageDark}
          quality={100}
          placeholder="blur"
          alt="Imagem de um celular do Transporte Generoso recebendo uma notificação"
        />
      </ImageContainer>
    </Container>
  );
};

export default Integracao;
